(function() {
    'use strict';

    angular
        .module('updateClientApp', ['corePRUGAGreatApp'])
})();
